import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DepartmentsComponent } from './view/page/departments/departments.component';
import { NotificationsComponent } from './view/page/notifications/notifications.component';
import { SubscriptionComponent } from './view/page/subscription/subscription.component';
import { RequestEditorComponent } from './view/page/request-editor/request-editor.component';
import { RequestQrcodeComponent } from './view/page/request-qrcode/request-qrcode.component';
import { RequestPreviewComponent } from './view/page/request-preview/request-preview.component';
import { RequestDepartmentComponent } from './view/page/request-department/request-department.component';
import { RequestUidScanningComponent } from './view/page/request-uid-scanning/request-uid-scanning.component';
import { SubscriptionViaBarcodeComponent } from './view/page/subscription-via-barcode/subscription-via-barcode.component';
import { RequestsComponent } from './view/page/requests/requests.component';
import { SettingsComponent } from './view/page/settings/settings.component';
import { HelpComponent } from './view/page/help/help.component';
import { FeedbackComponent } from './view/page/feedback/feedback.component';
import { PrintComponent } from './view/page/print/print.component';
import { requestEditorCanDeactivate } from './view/page/request-editor/guards/request-editor-leave';

const routes: Routes = [
    { path: '', component: RequestsComponent },
    { path: 'request-preview', component: RequestPreviewComponent },
    { path: 'request-department', component: RequestDepartmentComponent },
    {
        path: 'request-editor',
        component: RequestEditorComponent,
        canDeactivate: [requestEditorCanDeactivate],
    },
    { path: 'request-qrcode', component: RequestQrcodeComponent },
    { path: 'request-uid-scanning', component: RequestUidScanningComponent },
    { path: 'departments', component: DepartmentsComponent },
    { path: 'notifications', component: NotificationsComponent },
    { path: 'subscription-via-barcode', component: SubscriptionViaBarcodeComponent },
    { path: 'subscription', component: SubscriptionComponent },
    { path: 'settings', component: SettingsComponent },
    { path: 'feedback', component: FeedbackComponent },
    { path: 'print', component: PrintComponent },
    { path: 'help', component: HelpComponent },
    { path: '**', redirectTo: '/' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
